import { useReducer, useState } from 'react'
import { getDecodeBurstByVin } from '../../../api-client/integration'

const FAIL_COUNT_TO_SHOW_ANOTHER_ERROR = 2

const ActionTypes = {
  startLoading: 'startLoading',
  hasError: 'hasError',
  getVehicleSuccess: 'getVehicleSuccess',
}

export const Errors = {
  EMPTY_FIELD: 'EMPTY_FIELD',
  CANNOT_LOCATE_YOUR_VIN: 'CANNOT_LOCATE_YOUR_VIN',
  VIN_IS_NOT_VALID: 'VIN_IS_NOT_VALID',
  VEHICLE_BY_VIN_NOT_FOUND: 'VEHICLE_BY_VIN_NOT_FOUND',
  GENERAL_ERROR: 'GENERAL_ERROR',
}

const initialState = {
  isLoading: false,
  isSuccess: false,
  error: null,
  vehicle: null,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.startLoading:
      return { ...state, isLoading: true }

    case ActionTypes.hasError:
      return { ...state, isLoading: false, isSuccess: false, error: action.error }

    case ActionTypes.getVehicleSuccess:
      return { ...state, isLoading: false, isSuccess: true, error: null, vehicle: action.vehicle }

    default:
      return state
  }
}

export const useVinSearch = ({ onSuccess, onError }) => {
  const [vinFailCount, setVinFailCount] = useState(0)
  const [state, dispatch] = useReducer(reducer, initialState)

  /**
   * @param {string} vin
   */
  const search = async (vin) => {
    dispatch({ type: ActionTypes.startLoading })

    if (vin.length === 0) {
      return dispatch({ type: ActionTypes.hasError, error: Errors.EMPTY_FIELD })
    }

    try {
      const vehicle = await getDecodeBurstByVin({ vin })
      dispatch({ type: ActionTypes.getVehicleSuccess, vehicle })

      if (onSuccess) {
        onSuccess(vehicle)
      }
    } catch (err) {
      setVinFailCount((prev) => prev + 1)

      let error = Errors.GENERAL_ERROR
      const code = err?.errors?.[0]?.code

      if (vinFailCount + 1 >= FAIL_COUNT_TO_SHOW_ANOTHER_ERROR) {
        error = Errors.CANNOT_LOCATE_YOUR_VIN
      } else if (code === Errors.VIN_IS_NOT_VALID) {
        error = Errors.VIN_IS_NOT_VALID
      } else if (code === Errors.VEHICLE_BY_VIN_NOT_FOUND) {
        error = Errors.VEHICLE_BY_VIN_NOT_FOUND
      }

      dispatch({ type: ActionTypes.hasError, error })

      if (onError) {
        onError(error)
      }
    }
  }

  return {
    ...state,
    search,
  }
}
